import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        <span className="site-footer-brand">
          本網站僅提供資料下載，詳細信息請訪問：
          <a href="https://www.lionccm.org/" target="_blank" rel="noopener noreferrer">正覺精舍</a>，
          <a href="http://www.yttemple.com/" target="_blank" rel="noopener noreferrer">圓通寺</a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
